var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4d4d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.769,18H4.231A1.173,1.173,0,0,1,3,16.9V4.759a1.172,1.172,0,0,1,1.231-1.1H5.462v.552A1.758,1.758,0,0,0,7.308,5.862,1.758,1.758,0,0,0,9.154,4.207V3.655h3.692v.552a1.759,1.759,0,0,0,1.846,1.655,1.759,1.759,0,0,0,1.846-1.655V3.655h1.231A1.172,1.172,0,0,1,19,4.759V16.9A1.173,1.173,0,0,1,17.769,18Zm0-10.483H4.231V16.9H17.769ZM7.308,10.276H5.462V8.621H7.308Zm0,2.759H5.462V11.379H7.308Zm0,2.759H5.462V14.138H7.308Zm3.077-5.517H8.538V8.621h1.846Zm0,2.759H8.538V11.379h1.846Zm0,2.759H8.538V14.138h1.846Zm3.077-5.517H11.615V8.621h1.846Zm0,2.759H11.615V11.379h1.846Zm0,2.759H11.615V14.138h1.846Zm3.077-5.517H14.692V8.621h1.846Zm0,2.759H14.692V11.379h1.846Zm0,2.759H14.692V14.138h1.846ZM14.673,5.31a1.154,1.154,0,0,1-1.212-1.086V3.086a1.219,1.219,0,0,1,2.423,0V4.224A1.154,1.154,0,0,1,14.673,5.31Zm-7.385,0A1.154,1.154,0,0,1,6.077,4.224V3.086A1.154,1.154,0,0,1,7.289,2,1.154,1.154,0,0,1,8.5,3.086V4.224A1.155,1.155,0,0,1,7.289,5.31Z",
    transform: "translate(-3 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2967c79eec37d18c5dc779a62ccd53d2.svg";
export { ForwardRef as ReactComponent };